export * from './lib';
import { LRUCache } from './lib';

export { LRUCache }

export default LRUCache
